import React from "react";
import { CalendarIcon } from "../../../../components/Icons";
import NewEditIcon from "../../../../components/Icons/NewEditIcon";
import { SelectedSlot } from "../../../../state/urgent-visit";

interface ReviewScheduleCardProps {
  slot: SelectedSlot;
  formattedDate: string;
  isToday: boolean;
  weekday: string;
  errorMessage?: string;
  onEdit: () => void;
}

export const ReviewScheduleCard = ({
  slot,
  formattedDate,
  isToday,
  weekday,
  errorMessage,
  onEdit,
}: ReviewScheduleCardProps) => (
  <div className="flex flex-col gap-2">
    <p className="font-semibold text-sm text-light-black leading-[14px]">
      Scheduled For
    </p>
    <div className={`bg-white border rounded-lg p-3
      flex justify-between items-center
      ${errorMessage ? "border-red-5" : "border-taupe-50"}`}
    >
      <div className="flex gap-2 items-center">
        <CalendarIcon width={24} height={24} color="#262626" />
        <div className="flex gap-2 items-center flex-wrap text-sm
          font-semibold text-light-black"
        >
          <span>{isToday ? "Today" : weekday}</span>
          <span className="text-gray-4">|</span>
          <span className="whitespace-nowrap">{formattedDate} · {slot.label}</span>
        </div>
      </div>
      <div className="cursor-pointer" onClick={onEdit}>
        <NewEditIcon width={20} height={20} />
      </div>
    </div>
    {errorMessage && (
      <p className="text-xs text-red-5 leading-4">
        {errorMessage}
      </p>
    )}
  </div>
);
